import * as React from "react";
import PropTypes from "prop-types";
const SvgAchievementsKomHighlightedSmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M11.33 10.7l.67 1.25.67-1.25L12 9.44zm10.91 7.97H1.76v4h20.48z" />
        <path d="M22.68 4.56l-3.03 1.61L12 2.11 4.35 6.17 1.32 4.56l-.99.67 1.38 12.1h20.58l1.38-12.1zM12 14.83L9.8 10.7 12 6.56l2.2 4.14z" />
      </g>
    </svg>
  )
);
SvgAchievementsKomHighlightedSmall.defaultProps = {
  color: "currentColor",
  size: 24,
  title: undefined,
  titleId: undefined,
};
SvgAchievementsKomHighlightedSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgAchievementsKomHighlightedSmall;
